<template lang="pug">
div
  v-card.pa-6.mt-4.round-xl(outlined)
    div.text-md.font-semibold.neutral700--text Sharing
    v-row.mt-5(no-gutters)
      v-col(cols="5")
        div.text-sm.font-semibold.neutral500--text Register link
        v-text-field.text-sm.mt-2.round-xl(:value="registerLink()" outlined dense height="48" readonly :loading="isFetching" hide-details="auto")
          template(#append)
            v-icon.mt-1(size="24" color="neutral700" @click="handleCopyLink") $yzi-copy-03

    div.text-md.font-semibold.neutral700--text.mt-5 QR Code
    div.text-sm.neutral700--text You can print this or download the image and give to your registree

    div.mt-5.d-flex.align-center
      div.round-3xl.neutral700.pa-1
        vue-qrcode.round-3xl(id="registerlink" :value="registerLink()" :options="{ width: 104 }" style="margin-bottom: -6px;")
      div.ml-6(style="width: 200px")
        v-btn.round-lg.text-md.font-bold.text-none.pl-5.pr-4.py-3(color="basic700" outlined depressed height="48" @click="downloadPdf")
          v-icon(left color="basic700") mdi-file-pdf-box
          | {{ $t('download_as_pdf') }}
        v-btn.round-lg.text-md.font-bold.text-none.pl-5.pr-4.py-3.mt-4(color="basic700" outlined depressed height="48" @click="downloadPng")
          v-icon.mb-1(left color="basic700") $yzi-download-01
          | {{ $t('download_as_png') }}

  v-card.pa-6.mt-4.round-xl(outlined)
    v-form(ref="form")
      v-row
        v-col(cols="8")
          div.text-md.font-semibold.neutral700--text Register page welcoming text
          div.text-sm.neutral700--text This determine what people see when opening the register page.
          v-textarea.text-sm.mt-2.round-xl(v-model="settings.page_title" placeholder="Join our Loyalty program for amazing rewards!" outlined rows="6" hide-details="auto" :rules="rules.not_empty")
          
          div.text-md.font-semibold.neutral700--text.mt-4 Sub description text
          v-textarea.text-sm.mt-2.round-xl(v-model="settings.page_description" placeholder="Fill in the details below to register." outlined rows="6" hide-details="auto" :rules="rules.not_empty")
          
          div.text-md.font-semibold.neutral700--text.mt-4 Properties
          div.text-sm.neutral700--text Determine your needed data for registration

          template(v-for="(property, index) in properties")
            div.d-flex.align-center.mt-2
              v-checkbox.ma-0.pa-0(v-model="property.enabled" :disabled="!property.editable" hide-details :key="`pr-${index}`")
              div.text-md.font-normal.neutral700--text.py-1 {{ property.name }}
              div.required-editable-custom(v-if="!property.editable")
                div.text-xs.font-normal.neutral500--text Required by system
              div.required-editable-custom(v-else-if="property.enabled")
                div.d-flex.align-center
                  v-checkbox.ma-0.pa-0(v-model="property.required" dense hide-details)
                  div.text-xs.font-normal.neutral700--text Required
  div(ref="copy")
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import VueQrcode from '@chenfengyuan/vue-qrcode'

export default {
  components: { VueQrcode },
  data () {
    return {
      isFetching: false,
      isLoading: false,
      openSmsOfferDialog: false,
      openWhatsappOfferDialog: false,
      openEmailOfferDialog: false,
      openSmsThanksDialog: false,
      openWhatsappThanksDialog: false,
      openEmailThanksDialog: false,
      openDeliveranceDetailsDialog: false,
      openWhatsappDeliveranceDetailsDialog: false,
      openEmailDeliveranceDetailsDialog: false,
      openSmsThanksDetailsDialog: false,
      openWhatsappThanksDetailsDialog: false,
      openEmailThanksDetailsDialog: false,
      openDeleteDialog: false,
      selectedData: null,
      settings: {},
      blasts: [
        { type: 'first_purchase', data: null },
        { type: 'second_purchase', data: null },
        { type: 'reactivation', data: null }
      ],
      properties: [
        {
          name: 'Phone number',
          type: 'phone',
          placeholder: 'Enter your phone',
          required: true,
          enabled: true,
          editable: false
        },
        {
          name: 'Name',
          type: 'text',
          placeholder: 'Enter your name',
          required: false,
          enabled: false,
          editable: true
        },
      ],
      rules: {
        not_empty: [v => (v != null && v.toString().trim().length) || 'This field is required'],
        has_quantity: [v => !!v || 'This field is required', v => v != 0 || 'This field is required'],
        has_price: [(v) => !!v || 'This field is required', (v) => v >= 0 || `Amount should be more than ${this.$currency.symbol} 0`],
        not_empty_select: [v => !!v || 'This field is required']
      },
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      loyaltySettings: 'marketing/getLoyaltySettings'
    }),
  },
  mounted () {
    this.setData()
  },
  methods: {
    ...mapActions(['showMessage']),
    setData () {
      this.settings = this.loyaltySettings
      this.properties = this.loyaltySettings.page_properties.map(m => { return this.sanitizeObject(m) })
    },
    registerLink () {
      const companySlug = this.company.slug
      return `https://${companySlug}.yezza.co/loyalty/register`
    },
    saveData () {
      if (!this.$refs.form.validate()) {
        this.showMessage(['error', this.$t('error_message.please_fill_out_all_required')])
        return
      }
      let payload = { 
        page_title: this.settings.page_title,
        page_description: this.settings.page_description,
        page_properties: this.properties
      }
      this.$axios.patch(`/loyalty/${this.company.slug}`, payload)
        .then(resp => {
          this.$store.commit('marketing/setLoyaltySettings', resp.data)
          this.showMessage(['success', this.$t('success_message.successfully_updated')])
          this.$emit('updated')
          this.$nextTick(() => {
            this.setData()
          })
        })
        .catch(err => {
          let message = this.$t('error_message.unable_to_complete_request')
          if (err.response.data) {
            if (err.response.data.detail) {
              message = err.response.data.detail
            } else {
              let data = JSON.stringify(err.response.data).replace(/[^\w.\s:]/g, '').replace(/[.:]/g, match => match + ' ')
              if (data) { message = data }
            }
          }
          this.showMessage(['error', message])
          this.$emit('error')
        })
    },
    sanitizeObject (obj) {
      let newObj = {
        name: obj.name || '',
        type: obj.type || 'text',
        placeholder: obj.placeholder || '',
        required: obj.required || false,
        enabled: obj.enabled || false,
        editable: obj.editable === false ? false : true
      }
      return newObj
    },
    downloadPng () {
      var canvas = document.getElementById("registerlink")
      var dataURL = canvas.toDataURL("image/png")
      const linkSource = dataURL
      const downloadLink = document.createElement('a')
      document.body.appendChild(downloadLink)
      downloadLink.href = linkSource
      downloadLink.target = '_self'
      downloadLink.download = 'QrCode'
      downloadLink.click()
    },
    downloadPdf () {
      let qrUrl = encodeURI(`https://${process.env.VUE_APP_BASE_DOMAIN}/pdf-qr?link=${this.registerLink()}`)
      let downloadUrl = `https://pdf.yezza.io/?url=${qrUrl}&type=pdf&filename=qrcode.pdf&waitUntil=networkidle0&printBackground=true&width=305&height=305`
      window.open(downloadUrl)
    },
    reset () {
      this.fetchDeliverance()
    },
    closed () {
      this.selectedData = null
      this.openDeleteDialog = false
    },
    handleCopyLink () {
      let container = this.$refs.copy
      this.$copyText(this.registerLink(), container)
        .then(() => {
          this.showMessage(['success', this.$t('success_message.link_copied_to_clipboard')])
        })
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  cursor: default;
}
.required-editable-custom {
  margin-left: 16px;
  background-color: var(--v-neutral200);
  padding: 2px 5px 2px 5px;
  border-radius: 6px;
  border: 1px solid var(--v-neutral300);
}
::v-deep {
  .v-text-field--outlined {
    fieldset {
      border-color: var(--v-neutral400);
    }
  } 
  .error--text {
    color: var(--v-danger500) !important;
    fieldset {
      border-color: var(--v-danger500);
    }
  }
}
</style>